import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";

import { makeStyles } from "@mui/styles";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import { getRoleList } from "../../redux/actions/getRoleListAction";
import { getMappingRoleList } from "../../redux/actions/getMappingRoleListAction";
import { createRoleMapping } from "../../redux/actions/createRoleMappingAction";
import { deleteRoleMapping } from "../../redux/actions/deleteRoleMappingAction";
import { getEntityMappingList } from "../../redux/actions/getEntityMappingListAction";
import { getEntityTypeList } from "../../redux/actions/getEntityTypeListAction";
import { createEntityMappingList } from "../../redux/actions/createEntityMappingAction";
import { deleteEntityMappingList } from "../../redux/actions/deleteEntityMappingAction";
import { addOrUpdateEntityTypeList } from "../../redux/actions/addOrUpdateEntityTypeListAction";
import { getLoadLimitList } from "../../redux/actions/getLoadLimitListAction";
import { addOrUpdateLoadLimit } from "../../redux/actions/addOrUpdateLoadLImitAction";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import BackButton from "../../components/BackButton/BackButton";
import { adminLoyaltyPointOperation } from "../../redux/actions/adminLoyaltyPointOperationAction";
import { adminGetLoyaltyPoint } from "../../redux/actions/adminGetLoyaltyPointAction";
import { adminAddOrUpdateLoyaltyPoint } from "../../redux/actions/adminAddOrUpdateLoyalPointAction";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import Util from "../../validation/index";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SOLogout from "../../components/Logout/SOLogout";
import { adminCurrencyCode } from "../../redux/actions/adminCurrencyCodeAction";
import { getDefaultCurrencyList } from "../../redux/actions/adminCurrencyListAction";
import val from "../../getThemeDetails"
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const AdminLoyaltyManagement = () => {
	const [openLoyalty, setOpenLoyalty] = useState(false);

	// const [walletOwnerId, setWalletOwnerId] = useState("");
	const [role, setRole] = useState("");
	const [entityType, setEntityType] = useState("");
	const [page, setPage] = useState(0);
	const [Open, setOpen] = React.useState(false);
	const [editOpen, setEditOpen] = React.useState(false);
	const [viewOpen, setViewOpen] = React.useState(false);
	const [addOpen, setAddOpen] = React.useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [isLoading, setIsLoading] = useState(false);
	const [getWalletOwnerIdStatus, setGetWalletOwnerIdStatus] = useState(false);
	const [getWalletOwnerIdResArray, setGetWalletOwnerIdResArray] = useState([]);

	const [getLoyaltyPointListStatus, setGetLoyaltyPointListStatus] =
		useState(false);
	const [getLoyaltyPointListArray, setGetLoyaltyPointListArray] = useState([]);

	const [
		addOrUpdateLoyaltyPointListStatus,
		setAddOrUpdateLoyaltyPointListStatus
	] = useState(false);
	const [
		addOrUpdateLoyaltyPointListArray,
		setAddOrUpdateLoyaltyPointListArray
	] = useState([]);

	const [getRoleStatus, setGetRoleStatus] = useState(false);
	const [getRoleResArray, setGetRoleResArray] = useState([]);

	const [getRoleMappingStatus, setGetRoleMappingStatus] = useState(false);
	const [getRoleMappingResArray, setGetRoleMappingResArray] = useState([]);

	const [getEntityTypeStatus, setGetEntityTypeStatus] = useState(false);
	const [getEntityTypeResArray, setGetEntityTypeResArray] = useState([]);

	const [createRoleMappingStatus, setCreateRoleMappingStatus] = useState("");
	const [createRoleMappingResArray, setCreateRoleMappingResArray] = useState(
		[]
	);

	const [deleteRoleMappingStatus, setDeleteRoleMappingStatus] = useState("");
	const [deleteRoleMappingResArray, setDeleteRoleMappingResArray] = useState(
		[]
	);

	const view = "view";
	const edit = "edit";

	const add = "Add";
	const update = "Update";

	const [mappingId, setMappingId] = useState("");

	const [notificationOpen, setNotificationOpen] = React.useState(false);

	const [search, setSearch] = useState({
		searchWalletId: "",
		searchOperation: "",
		searchCurrency: ""
	});

	const { searchWalletId, searchOperation, searchCurrency } = search;

	const searchInputChange = (e) => {
		setSearch({ ...search, [e.target.name]: e.target.value });
	};

	const login = useSelector(({ login }) => login);

	const [user, setUser] = useState({
		loyaltyPointId: "",
		walletOwnerId: "",
		operationType: "",
		currency: "",
		amountUnit: "",
		loyaltyPoints: "",
		amountValue: "",
		minimumThreshold: ""
	});

	const {
		loyaltyPointId,
		walletOwnerId,
		operationType,
		currency,
		amountUnit,
		loyaltyPoints,
		amountValue,
		minimumThreshold
	} = user;

	const onInputChange = ({ target: { name, value } }, type) => {
		// setUser({ ...user, [e.target.name]: e.target.value });
		const obj = {
			...user
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else if (type == "amount") {
			obj[name] = Util.verifyAmount(value) ? value : obj[name];
		} else {
			// obj[name] = value.trim()
			obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
		}
		setUser(obj);
		const wltOwnrId = obj.walletOwnerId.substring(0, obj.walletOwnerId.indexOf('-'));
		const reqs = {
			loginDetails: {
				walletOwnerId: wltOwnrId,
				role: login.data.subRole,
			}
		}
		dispatch(getDefaultCurrencyList(reqs, authToken));
	};

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);

	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();
	const dispatch = useDispatch();

	useEffect(() => {
		const adminCurrReq = {
			loginDetails: {
				adminId: regenerateTokenRes.data.partnerId
			}
		}
		dispatch(adminCurrencyCode(adminCurrReq, authToken));
	}, [authToken])


	const adminCurrencyCodes = useSelector(({ adminCurrencyCode }) => adminCurrencyCode);

	const getWalletOwnerIdRes = useSelector(
		({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
	);

	const operationList = useSelector(
		({ adminLoyaltyPointOperation }) => adminLoyaltyPointOperation
	);

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const getLoyaltyPointListRes = useSelector(
		({ adminGetLoyaltyPoint }) => adminGetLoyaltyPoint
	);

	const addOrUpdateLoyaltyPointRes = useSelector(
		({ adminAddOrUpdateLoyalPoint }) => adminAddOrUpdateLoyalPoint
	);
	const getRoleListRes = useSelector(({ getRoleList }) => getRoleList);

	const getEntityTypeListRes = useSelector(
		({ getEntityTypeList }) => getEntityTypeList
	);

	const getRoleMappingListRes = useSelector(
		({ getMappingRoleList }) => getMappingRoleList
	);

	const createRoleMappingRes = useSelector(
		({ createRoleMapping }) => createRoleMapping
	);

	const deleteRoleMappingRes = useSelector(
		({ deleteRoleMapping }) => deleteRoleMapping
	);

	const operationListReq = () => {
		let req = {
			loginDetails: {
				walletOwnerId: "2"
			}
		};
		dispatch(adminLoyaltyPointOperation(req, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			operationListReq();
			getWalletOwnerIdAndNameListReq();
			getLoyaltyPointListReq();
			getRoleListReq();
			getRoleMappingListReq();
		}
	}, [regenerateTokenRes.data.AuthToken]);

	// useEffect(() => {
	// 	operationListReq();
	// }, []);

	const handleNoticationClose = () => {
		setCreateRoleMappingResArray([]);
		setDeleteRoleMappingResArray([]);
		// setWalletOwnerId("");
		// setRole("");
		setNotificationOpen(false);
	};

	// const handleChange = ({ target: { name, value } }) => {
	// 	if (name === "walletOwnerId") {
	// 		setWalletOwnerId(value == "Select Level" ? "" : value);
	// 	}

	// 	if (name === "role") {
	// 		setRole(value);
	// 	}
	// };

	const getWalletOwnerIdStatusFunc = () => {
		if (getWalletOwnerIdStatus) {
			if (getWalletOwnerIdRes.data.status == "success") {
				setGetWalletOwnerIdResArray(
					[].concat(getWalletOwnerIdRes.data.ownerList)
				);
			}
			if (getEntityTypeListRes.data.status == "failed") {
				setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
				if (
					getEntityTypeListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getEntityTypeListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	const getWalletOwnerIdAndNameListReq = () => {
		setGetWalletOwnerIdStatus(true);
		dispatch(
			getWalletOwnerIdAndNameList(
				{
					loginDetails: {
						// adminId: "2"
						adminId: val.adminIDS

					}
				},
				authToken
			)
		);
	};

	// useEffect(() => {
	// 	getWalletOwnerIdAndNameListReq();
	// }, []);

	useEffect(() => {
		getWalletOwnerIdStatusFunc();
	}, [getWalletOwnerIdRes.data.status]);

	const getRoleListStatusFunc = () => {
		if (getRoleStatus) {
			if (getRoleListRes.data.status == "success") {
				setGetRoleResArray([].concat(getRoleListRes.data.roleList));
			}
			if (getRoleListRes.data.status == "failed") {
				setGetRoleResArray(getRoleListRes.data);
				if (
					getRoleListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getRoleListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	const getLoyaltyPointListReq = () => {
		setGetLoyaltyPointListStatus(true);
		setIsLoading(true);
		let req = {
			actionCustomerMasterRequestVO: {
				currency: searchCurrency == "Select Currency" ? "" : searchCurrency.substring(searchCurrency.indexOf('-') + 1),
				operationId:
					searchOperation == "Select Operation" ? "" : searchOperation
			},
			loginDetails: {
				walletOwnerId: searchWalletId == "Select Owner ID" ? "" : searchWalletId.substring(0, searchWalletId.indexOf('-'))
			}
		};
		dispatch(adminGetLoyaltyPoint(req, authToken));
	};

	const getLoyaltyPointListFunc = () => {
		if (getLoyaltyPointListStatus) {
			if (getLoyaltyPointListRes.data.status == "success") {
				setGetLoyaltyPointListArray(
					[].concat(getLoyaltyPointListRes.data.loyaltyPointsList)
				);
				setIsLoading(false);
			}
			if (getLoyaltyPointListRes.data.status == "failed") {
				setGetLoyaltyPointListArray(getLoyaltyPointListRes.data);
				setIsLoading(false);
				NotificationPopups(
					"error",
					"Failed",
					getLoyaltyPointListRes.data.description
				);
				if (
					getLoyaltyPointListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getLoyaltyPointListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getLoyaltyPointListRes.data.status == "Failed") {
				setGetLoyaltyPointListArray(getLoyaltyPointListRes.data);
				setIsLoading(false);
				NotificationPopups(
					"error",
					"Failed",
					getLoyaltyPointListRes.data.description
				);
				if (
					getLoyaltyPointListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getLoyaltyPointListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getLoyaltyPointListRes.data.status == "NOT FOUND") {
				setGetLoyaltyPointListArray(getLoyaltyPointListRes.data);
				setIsLoading(false);
				NotificationPopups(
					"error",
					"Failed",
					getLoyaltyPointListRes.data.status
				);
			}
		}
	};

	useEffect(() => {
		getLoyaltyPointListFunc();
	}, [getLoyaltyPointListRes.data.status]);

	const setData = (row, fs) => {
		if (fs == "view") {
			setViewOpen(true);
		}
		if (fs == "edit") {
			setEditOpen(true);
		}
		var data = {};
		data =
			operationList.success &&
			[]
				.concat(operationList.data.actionCustomerMasterResponseVOList)
				.filter((x) =>
					x.operationName == row.operationId ? x.operationId : ""
				);
		setUser({
			loyaltyPointId: row.loyaltyPointId,
			walletOwnerId: row.walletOwnerId,
			operationType: data[0].operationId,
			currency: row.amountCurrency,
			amountUnit: row.unitAmount,
			loyaltyPoints: row.loyaltyPoints,
			amountValue: row.amountValue,
			minimumThreshold: row.minimumLoyaltyPointThreshold
		});
	};

	const addOrUpdateLoyaltyPointReq = (e, type) => {
		setAddOrUpdateLoyaltyPointListStatus(true);
		setEditOpen(false);
		setAddOpen(false);
		let req = {
			loginDetails: {
				walletOwnerId:
					walletOwnerId == "Select Owner ID" ? "" : walletOwnerId.split("-")[0]
			},
			SettingsRequestVO: {
				action: type,
				loyaltyPointId: loyaltyPointId,
				operationId: operationType == "Select Operation" ? "" : operationType,
				amountCurrency: currency == "Select Currency" ? "" : currency,
				unitAmount: amountUnit,
				loyaltyPoints: loyaltyPoints,
				amountValue: amountValue,
				minimumLoyaltyPointThreshold: minimumThreshold
			}
		};
		dispatch(adminAddOrUpdateLoyaltyPoint(req, authToken));
	};

	const addOrUpdateLoyaltyPointFunc = () => {
		if (addOrUpdateLoyaltyPointListStatus) {
			if (addOrUpdateLoyaltyPointRes.data.status == "success") {
				setAddOrUpdateLoyaltyPointListArray(
					[].concat(addOrUpdateLoyaltyPointRes.data)
				);
				setNotificationOpen(true);
			}
			if (addOrUpdateLoyaltyPointRes.data.status == "failed") {
				setAddOrUpdateLoyaltyPointListArray(addOrUpdateLoyaltyPointRes.data);
				setNotificationOpen(true);
				if (
					addOrUpdateLoyaltyPointRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					addOrUpdateLoyaltyPointRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (addOrUpdateLoyaltyPointRes.data.status == "Failed") {
				setAddOrUpdateLoyaltyPointListArray(addOrUpdateLoyaltyPointRes.data);
				setNotificationOpen(true);
				if (
					addOrUpdateLoyaltyPointRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					addOrUpdateLoyaltyPointRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		addOrUpdateLoyaltyPointFunc();
	}, [addOrUpdateLoyaltyPointRes.data.status]);

	const getRoleListReq = () => {
		setGetRoleStatus(true);
		dispatch(
			getRoleList(
				{
					ownerMasterRequestVO: {
						// adminId: 2
						adminId: val.adminIDS

					}
				},
				authToken
			)
		);
	};

	useEffect(() => {
		console.log(
			currency,
			"/////////////////////////////////<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<"
		);
	}, [currency]);

	useEffect(() => {
		getRoleListStatusFunc();
	}, [getRoleListRes.data.status]);

	const getEntityListStatusFunc = () => {
		if (getEntityTypeStatus) {
			if (getEntityTypeListRes.data.status == "success") {
				setGetEntityTypeResArray([].concat(getEntityTypeListRes.data.roleList));
			}
			if (getEntityTypeListRes.data.status == "failed") {
				setGetEntityTypeResArray(getEntityTypeListRes.data);
				if (
					getEntityTypeListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getEntityTypeListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getEntityListStatusFunc();
	}, [getEntityTypeListRes.data.status]);

	const getEntityTypeListReq = () => {
		setGetEntityTypeStatus(true);
		dispatch(
			getEntityTypeList(
				{
					ownerMasterRequestVO: {
						// adminId: 2,
						adminId: val.adminIDS,

						entityType: entityType
					}
				},
				authToken
			)
		);
	};

	// useEffect(() => {
	// 	getEntityTypeListReq();
	// }, []);

	const getRoleMappingListReq = () => {
		setOpen(false);
		setGetRoleMappingStatus(true);
		dispatch(
			getMappingRoleList(
				{
					ownerMasterRequestVO: {
						// adminId: 2
						adminId: val.adminIDS

					}
				},
				authToken
			)
		);
	};

	// useEffect(() => {
	// 	getRoleMappingListReq();
	// }, []);

	const getRoleMappingStatusFunc = () => {
		if (getRoleMappingStatus) {
			if (getRoleMappingListRes.data.status == "success") {
				setGetRoleMappingResArray(
					[].concat(getRoleMappingListRes.data.roleList)
				);
			}
			if (getRoleMappingListRes.data.status == "failed") {
				setGetRoleMappingResArray(getRoleMappingListRes.data);
				if (
					getRoleMappingListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getRoleMappingListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getRoleMappingStatusFunc();
	}, [getRoleMappingListRes.data.status]);

	// const createRoleMappingReq = () => {
	// 	setCreateRoleMappingStatus(true);
	// 	const createMappingReq = {
	// 		ownerMasterRequestVO: {
	// 			adminId: 2,
	// 			ownerID: walletOwnerId.split("-")[0],
	// 			roleName: role
	// 		}
	// 	};
	// 	dispatch(createRoleMapping(createMappingReq, authToken));
	// };

	const createRoleMappingStatusFunc = () => {
		console.log(getRoleMappingListRes, "/////////////////////////");
		if (createRoleMappingStatus) {
			if (createRoleMappingRes.data.status == "success") {
				setCreateRoleMappingResArray(createRoleMappingRes.data);
				setNotificationOpen(true);
				getRoleMappingListReq();
			}
			if (createRoleMappingRes.data.status == "failed") {
				setCreateRoleMappingResArray(createRoleMappingRes.data);
				setNotificationOpen(true);
				if (
					createRoleMappingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					createRoleMappingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (createRoleMappingRes.data.status == "INVALID REQUEST") {
				setCreateRoleMappingResArray(createRoleMappingRes.data);
				setNotificationOpen(true);
			}
		}
	};

	useEffect(() => {
		createRoleMappingStatusFunc();
	}, [createRoleMappingRes.data.status]);

	const deleteEntityMappingReq = () => {
		setDeleteRoleMappingStatus(true);
		const deleteMappingReq = {
			ownerMasterRequestVO: {
				// adminId: 2,
				adminId: val.adminIDS,
				
				mappingId: mappingId
			}
		};
		dispatch(deleteRoleMapping(deleteMappingReq, authToken));
	};

	console.log(deleteRoleMappingRes, "////////////////////");

	const deleteRoleMappingStatusFunc = () => {
		console.log(deleteRoleMappingRes, "////////////////////1");
		if (deleteRoleMappingStatus) {
			console.log(deleteRoleMappingRes, "////////////////////2");
			if (deleteRoleMappingRes.data.status == "success") {
				setDeleteRoleMappingResArray(deleteRoleMappingRes.data);
				console.log(deleteRoleMappingRes, "////////////////////3");
				setNotificationOpen(true);
				getRoleMappingListReq();
			}
			if (deleteRoleMappingRes.data.status == "failed") {
				setDeleteRoleMappingResArray(deleteRoleMappingRes.data);
				setNotificationOpen(true);
				if (
					deleteRoleMappingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					deleteRoleMappingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		deleteRoleMappingStatusFunc();
	}, [deleteRoleMappingRes.data.status]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleClose = () => {
		setEditOpen(false);
		setViewOpen(false);
		setAddOpen(false);
		setUser({
			walletOwnerId: "",
			operationType: "",
			currency: "",
			amountUnit: "",
			loyaltyPoints: "",
			amountValue: "",
			minimumThreshold: ""
		});
	};

	const addLoyalty = () => {
		setAddOpen(true);
	};

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					<Grid
						container
						style={{ padding: "15px", justifyContent: "space-between" }}
						spacing={2}
					>
						<Grid item md={4} sm={12} lg={9}></Grid>
						<Grid item xs={12} md={4} sm={12} lg={3}>
							<Button
								size="small"
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								className="riskRuleButton"
								onClick={addLoyalty}
							>
								Add Loyalty Point
							</Button>
						</Grid>
					</Grid>
					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Owner ID"
								fullWidth={true}
								name="searchWalletId"
								defaultValue={"Select Owner ID" || searchWalletId}
								onChange={searchInputChange}
							>
								<MenuItem value="Select Owner ID" selected="Select Owner ID">
									Select Owner ID
								</MenuItem>
								{getWalletOwnerIdRes.data.ownerList &&
									getWalletOwnerIdResArray.map((x) => (
										<MenuItem value={x}>{x}</MenuItem>
									))}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Operation"
								fullWidth={true}
								name="searchOperation"
								defaultValue={"Select Operation" || searchOperation}
								onChange={searchInputChange}
							>
								<MenuItem value="Select Operation" selected="Select Operation">
									Select Operation
								</MenuItem>
								{operationList.data.actionCustomerMasterResponseVOList &&
									operationList.data.actionCustomerMasterResponseVOList.map(
										(x) => (
											<MenuItem value={x.operationId}>
												{x.operationName}
											</MenuItem>
										)
									)}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Currency"
								fullWidth={true}
								name="searchCurrency"
								// value={role || "Select Level"}
								defaultValue={"Select Currency" || searchCurrency}
								onChange={searchInputChange}
							>
								<MenuItem value="Select Currency" selected="Select Currency">
									Select Currency
								</MenuItem>
								{
									adminCurrencyCodes.success &&
									[]
										.concat(adminCurrencyCodes.data.currencyList)
										.map((x) => <MenuItem value={x}>{x.substring(x.indexOf('-') + 1)}</MenuItem>)}
							</TextField>
						</Grid>
						<Grid item sm={12} md={3} lg={3}>
							<Button
								style={{
									marginLeft: "0.7rem",
									backgroundColor: "#00b9f5",
									color: "white",
									marginTop: "9px"
								}}
								endIcon={<AiOutlineSearch />}
								variant="contained"
								onClick={getLoyaltyPointListReq}
							>
								Search
							</Button>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getLoyaltyPointListArray.length == undefined ||
					getLoyaltyPointListArray.status == "NOT FOUND" ||
					!getLoyaltyPointListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"
								>
									Owner Details
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									{/* {getLoyaltyPointListArray.description &&
										(getLoyaltyPointListArray.description ||
											"No Records Found!")} */}
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}>
									Owner Details
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Owner ID
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Operation
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Currency
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getLoyaltyPointListArray &&
											[]
												.concat(getLoyaltyPointListArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow>
														<TableCell align="center">
															{row.walletOwnerId}
														</TableCell>
														<TableCell align="center">
															{row.operationId}
														</TableCell>
														<TableCell align="center">
															{row.amountCurrency}
														</TableCell>
														<TableCell align="center">
															<CustomButton
																style={{
																	padding: "8px",
																	margin: "0 8px"
																}}
																onClick={() => setData(row, view)}
															>
																<VisibilityIcon style={{ color: "#fff" }} />
															</CustomButton>
															<CustomButton
																style={{
																	padding: "8px",
																	margin: "0 8px"
																}}
																onClick={() => setData(row, edit)}
															>
																<EditIcon style={{ color: "#fff" }} />
															</CustomButton>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getLoyaltyPointListArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onChangePage={handleChangePage}
									onChangeRowsPerPage={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}

				<div>
					<Dialog open={editOpen} onClose={handleClose}>
						<DialogTitle>Edit Loyalty Points</DialogTitle>
						<DialogContent>
							<TextField
								required
								select
								size="small"
								color="primary"
								type="text"
								label="Owner ID"
								fullWidth={true}
								name="walletOwnerId"
								defaultValue={walletOwnerId || "Select Owner ID"}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="Select Owner ID" selected="Select Owner ID">
									Select Owner ID
								</MenuItem>
								{getWalletOwnerIdRes.data.ownerList &&
									getWalletOwnerIdResArray.map((x) => (
										<MenuItem value={x.split("-")[0]}>{x}</MenuItem>
									))}
							</TextField>

							<TextField
								required
								select
								size="small"
								color="primary"
								type="text"
								label="Operation"
								fullWidth={true}
								name="operationType"
								defaultValue={operationType || "Select Operation"}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="Select Operation" selected="Select Operation">
									Select Operation
								</MenuItem>
								{operationList.data.actionCustomerMasterResponseVOList &&
									operationList.data.actionCustomerMasterResponseVOList.map(
										(x) => (
											<MenuItem value={x.operationId}>
												{x.operationName}
											</MenuItem>
										)
									)}
							</TextField>

							<TextField
								required
								select
								size="small"
								color="primary"
								type="text"
								label="Currency"
								fullWidth={true}
								name="searchCurrency"
								// value={role || "Select Level"}
								defaultValue={currency || "Select Currency"}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="Select Currency" selected="Select Currency">
									Select Currency
								</MenuItem>
								{adminCurrencyList.success &&
									[].concat(adminCurrencyList.data.currencyList).map((x) => (
										<MenuItem value={x}>{x}</MenuItem>
									))}
							</TextField>

							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Amount Unit"
								fullWidth={true}
								name="amountUnit"
								value={amountUnit || ""}
								// onChange={(e) => onInputChange(e)}
								onChange={(e) => onInputChange(e, "amount")}
							></TextField>

							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Loyalty Points"
								fullWidth={true}
								name="loyaltyPoints"
								value={loyaltyPoints || ""}
								// onChange={(e) => onInputChange(e)}
								onChange={(e) => onInputChange(e, "amount")}
							></TextField>

							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Amount Value"
								fullWidth={true}
								name="amountValue"
								value={amountValue || ""}
								// onChange={(e) => onInputChange(e)}
								onChange={(e) => onInputChange(e, "amount")}
							></TextField>

							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Minimum Threshold"
								fullWidth={true}
								name="minimumThreshold"
								value={minimumThreshold || ""}
								// onChange={(e) => onInputChange(e)}
								onChange={(e) => onInputChange(e, "amount")}
							></TextField>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={(e) => addOrUpdateLoyaltyPointReq(e, update)}
							>
								Save
							</Button>
						</DialogActions>
					</Dialog>
				</div>
				<div>
					<Dialog open={viewOpen} onClose={handleClose}>
						<DialogTitle>View Loyalty Points</DialogTitle>
						<DialogContent>
							<TextField
								required
								disabled
								select
								size="small"
								color="primary"
								type="text"
								label="Owner ID"
								fullWidth={true}
								name="walletOwnerId"
								defaultValue={walletOwnerId || "Select Owner ID"}
								variant="standard"
							>
								<MenuItem value="Select Owner ID" selected="Select Owner ID">
									Select Owner ID
								</MenuItem>
								{getWalletOwnerIdRes.data.ownerList &&
									getWalletOwnerIdResArray.map((x) => (
										<MenuItem value={x.split("-")[0]}>{x}</MenuItem>
									))}
							</TextField>

							<TextField
								required
								disabled
								select
								size="small"
								color="primary"
								type="text"
								label="Operation"
								fullWidth={true}
								name="operationType"
								defaultValue={operationType || "Select Operation"}
								variant="standard"

							>
								<MenuItem value="Select Operation" selected="Select Operation">
									Select Operation
								</MenuItem>
								{operationList.data.actionCustomerMasterResponseVOList &&
									operationList.data.actionCustomerMasterResponseVOList.map(
										(x) => (
											<MenuItem value={x.operationId}>
												{x.operationName}
											</MenuItem>
										)
									)}
							</TextField>

							<TextField
								required
								disabled
								select
								size="small"
								color="primary"
								type="text"
								label="Currency"
								fullWidth={true}
								name="searchCurrency"
								// value={role || "Select Level"}
								defaultValue={currency || "Select Currency"}
								variant="standard"

							>
								<MenuItem value="Select Currency" selected="Select Currency">
									Select Currency
								</MenuItem>
								{adminCurrencyList.success &&
									[].concat(adminCurrencyList.data.currencyList).map((x) => (
										<MenuItem value={x}>{x}</MenuItem>
									))}
							</TextField>

							<TextField
								required
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Amount Unit"
								fullWidth={true}
								name="amountUnit"
								value={amountUnit || ""}
								onChange={(e) => onInputChange(e)}
								variant="standard"

							></TextField>

							<TextField
								required
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Loyalty Points"
								fullWidth={true}
								name="loyaltyPoints"
								value={loyaltyPoints || ""}
								onChange={(e) => onInputChange(e)}
								variant="standard"

							></TextField>

							<TextField
								required
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Amount Value"
								fullWidth={true}
								name="amountValue"
								value={amountValue || ""}
								onChange={(e) => onInputChange(e)}
								variant="standard"

							></TextField>

							<TextField
								required
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Minimum Threshold"
								fullWidth={true}
								name="minimumThreshold"
								value={minimumThreshold || ""}
								onChange={(e) => onInputChange(e)}
								variant="standard"

							></TextField>
						</DialogContent>
						<DialogActions>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Close
							</Button>
						</DialogActions>
					</Dialog>
				</div>
				<div>
					<Dialog open={addOpen} onClose={handleClose}>
						<DialogTitle style={{ minWidth: "600px" }}>
							Add Loyalty Points
						</DialogTitle>
						<DialogContent>
							<TextField
								required
								select
								size="small"
								color="primary"
								type="text"
								label="Owner ID"
								fullWidth={true}
								name="walletOwnerId"
								defaultValue={walletOwnerId || "Select Owner ID"}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="Select Owner ID" selected="Select Owner ID">
									Select Owner ID
								</MenuItem>
								{getWalletOwnerIdRes.data.ownerList &&
									getWalletOwnerIdResArray.map((x) => (
										<MenuItem value={x}>{x}</MenuItem>
									))}
							</TextField>

							<TextField
								required
								select
								size="small"
								color="primary"
								type="text"
								label="Operation"
								fullWidth={true}
								name="operationType"
								defaultValue={operationType || "Select Operation"}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="Select Operation" selected="Select Operation">
									Select Operation
								</MenuItem>
								{operationList.data.actionCustomerMasterResponseVOList &&
									operationList.data.actionCustomerMasterResponseVOList.map(
										(x) => (
											<MenuItem value={x.operationId}>
												{x.operationName}
											</MenuItem>
										)
									)}
							</TextField>

							<TextField
								required
								select
								size="small"
								color="primary"
								type="text"
								label="Currency"
								fullWidth={true}
								name="currency"
								// value={role || "Select Level"}
								defaultValue={currency || "Select Currency"}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="Select Currency" selected="Select Currency">
									Select Currency
								</MenuItem>
								{adminCurrencyList.success &&
									[].concat(adminCurrencyList.data.currencyList).map((x) => (
										<MenuItem value={x}>{x}</MenuItem>
									))}
							</TextField>

							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Amount Unit"
								fullWidth={true}
								name="amountUnit"
								value={amountUnit || ""}
								// onChange={(e) => onInputChange(e)}
								onChange={(e) => onInputChange(e, "amount")}
							></TextField>

							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Loyalty Points"
								fullWidth={true}
								name="loyaltyPoints"
								value={loyaltyPoints || ""}
								// onChange={(e) => onInputChange(e)}
								onChange={(e) => onInputChange(e, "amount")}
							></TextField>

							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Amount Value"
								fullWidth={true}
								name="amountValue"
								value={amountValue || ""}
								// onChange={(e) => onInputChange(e)}
								onChange={(e) => onInputChange(e, "amount")}
							></TextField>

							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Minimum Threshold"
								fullWidth={true}
								name="minimumThreshold"
								value={minimumThreshold || ""}
								// onChange={(e) => onInputChange(e)}
								onChange={(e) => onInputChange(e, "amount")}
							></TextField>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={(e) => addOrUpdateLoyaltyPointReq(e, add)}
							>
								Save
							</Button>
						</DialogActions>
					</Dialog>
				</div>

				{/* <div>
                    <Dialog open={Open} onClose={handleClose}>
                        <DialogTitle style={{ width: "400px" }}>Are you sure?</DialogTitle>
                        <DialogActions className="p-3">
                            <Button
                                style={{
                                    backgroundColor: "#fff",
                                    color: "#000",
                                }}
                                variant="contained"
                                onClick={handleClose}
                            >
                                Cancel
                            </Button>
                            <Button
                                style={{
                                    backgroundColor: "#00b9f5",
                                    color: "white",
                                }}
                                variant="contained"
                                onClick={deleteEntityMappingReq}
                            >
                                Yes
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div> */}
			</Layout>

			{addOrUpdateLoyaltyPointListArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateLoyaltyPointListArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addOrUpdateLoyaltyPointListArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateLoyaltyPointListArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
			{addOrUpdateLoyaltyPointListArray.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateLoyaltyPointListArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
			{/* 
            {
                createRoleMappingResArray.status == "INVALID REQUEST" && (
                    <div>
                        <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                            <DialogContent
                                className="text-center"
                                style={{ backgroundColor: "#00b9f51c" }}
                            >
                                <img src={failed} alt="" width="100px" className="my-2" />
                            </DialogContent>
                            <DialogContent>
                                <h4
                                    style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                                >
                                    {createRoleMappingResArray.description}
                                </h4>
                            </DialogContent>
                            <DialogActions style={{ justifyContent: "center" }}>
                                <Button
                                    style={{
                                        margin: "10px 0",
                                        backgroundColor: "#00b9f5",
                                        color: "white",
                                    }}
                                    variant="contained"
                                    onClick={handleNoticationClose}
                                >
                                    Ok
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                )
            }

            {
                deleteRoleMappingResArray.status == "success" && (
                    <div>
                        <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                            <DialogContent
                                className="text-center"
                                style={{ backgroundColor: "#00b9f51c" }}
                            >
                                <img src={success} alt="" width="100px" className="my-2" />
                            </DialogContent>
                            <DialogContent>
                                <h4
                                    style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                                >
                                    {deleteRoleMappingResArray.description}
                                </h4>
                            </DialogContent>
                            <DialogActions style={{ justifyContent: "center" }}>
                                <Button
                                    style={{
                                        margin: "10px 0",
                                        backgroundColor: "#00b9f5",
                                        color: "white",
                                    }}
                                    variant="contained"
                                    onClick={handleNoticationClose}
                                >
                                    Ok
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                )
            }

            {
                deleteRoleMappingResArray.status == "failed" && (
                    <div>
                        <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                            <DialogContent
                                className="text-center"
                                style={{ backgroundColor: "#00b9f51c" }}
                            >
                                <img src={failed} alt="" width="100px" className="my-2" />
                            </DialogContent>
                            <DialogContent>
                                <h4
                                    style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                                >
                                    {deleteRoleMappingResArray.description}
                                </h4>
                            </DialogContent>
                            <DialogActions style={{ justifyContent: "center" }}>
                                <Button
                                    style={{
                                        margin: "10px 0",
                                        backgroundColor: "#00b9f5",
                                        color: "white",
                                    }}
                                    variant="contained"
                                    onClick={handleNoticationClose}
                                >
                                    Ok
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                )
            } */}
		</>
	);
};

export default AdminLoyaltyManagement;
